import { render, staticRenderFns } from "./pos-invoice-checkout.vue?vue&type=template&id=38aa3954&scoped=true&"
import script from "./pos-invoice-checkout.ts?vue&type=script&lang=ts&"
export * from "./pos-invoice-checkout.ts?vue&type=script&lang=ts&"
import style0 from "./pos-invoice-checkout.scss?vue&type=style&index=0&id=38aa3954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa3954",
  null
  
)

export default component.exports